import { render } from "./View.vue?vue&type=template&id=5fccf683&lang=pug"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"
script.render = render

export default script